/* Notes

- canOverwrite method to check whether the current page can be overwritten
  by cached content?

- Need a "sanity check" value which can be compared to see if the cached
  content matches. Default could be length of html, or don't use by default.
  For cag it's the href of the next link as this contains the order_token

- use #fragment to remember which page we're at, might solve above problems

*/

(function(window, factory) {
  // universal module definition - thanks @desandro
  /* eslint-disable eqeqeq, no-undef */
  if (typeof define == "function" && define.amd) {
    // AMD
    define(["jquery"], factory);
  } else if (typeof module == "object" && module.exports) {
    // CommonJS
    module.exports = factory(require("jquery"));
  } else {
    // browser global
    window.InfScr = factory(window.jQuery);
  }
  /* eslint-enable eqeqeq, no-undef */
})(window, function factory($) {
  "use strict";

  function InfScr(container, options) {
    /* Create an infinite-scrolling page from a container with pagination.

       Options:

       nextSelector: css selector to find the "next page" link
       contentSelector: selector to find content
       autoOffset: distance from bottom to trigger auto-load
       callback: function called on content load
       bind: whether to bind the resize/scroll handlers directly to the window
       get_url: function to get the next page url from a link

       If bind is false, the resize method must be called before the
       auto-load behaviour will work. */

    options = $.extend(
      {
        nextSelector: null,
        contentSelector: null,
        autoOffset: null,
        bind: false,
        vertical: true,
        is_cached: false,
        id: "std",
        get_url: function(link) {
          return link.attr("href");
        },
        get_content: function(data) {
          return data;
        },
        getCacheKey: function(id) {
          // TODO get a unique key for the instance/url etc
          return `infscr_cache/${id}${window.location.pathname}${
            window.location.search
          }`;
        },
        beforeLoad: null,
        onLoad: null
      },
      options
    );
    var loading = false;
    var winHeight;
    var winWidth;
    var containerOffset;
    var autoLoadThreshold;
    var setThreshold;
    var xhr;

    if (options.is_cached) {
      var cached = window.sessionStorage.getItem(
        options.getCacheKey(options.id)
      );
      if (cached) {
        // assume cached is a superset of the current items. TODO check this is
        // actually the case
        // console.log('Adding', container.html().length, cached.length);

        var tempEl = $("<div>").html(cached);
        var currentItems = container.find(options.contentSelector);
        var newItems = tempEl
          .find(options.contentSelector)
          .slice(currentItems.length);
        var nextHref = tempEl.find(options.nextSelector).attr("href");

        var nextEl = container.find(options.nextSelector);

        nextEl.attr("href", nextHref);
        newItems.insertBefore(nextEl);
        // container.append(newItems);
        options.onLoad(newItems, container);
      } else {
        window.sessionStorage.setItem(
          options.getCacheKey(options.id),
          container.html()
        );
      }
    }

    function cancelXhr() {
      if (xhr) {
        xhr.abort();
      }
    }

    function append(url) {
      if (!loading) {
        container.addClass("loading-more");
        loading = true;
        cancelXhr();
        if (options.beforeLoad) {
          options.beforeLoad();
        }
        // TODO get rid of jquery, use window.fetch
        xhr = $.get(url, function(data) {
          var html = options.get_content(data);
          var content = $("<div>").html(html);
          var nextHref = content.find(options.nextSelector).attr("href");
          var link = container.find(options.nextSelector);
          var newContent = content.find(options.contentSelector);

          if (link.length) {
            newContent.insertBefore(link);
          } else {
            container.append(newContent);
          }
          container.removeClass("loading-more");

          if (nextHref) {
            link.attr("href", nextHref);
          } else {
            link.remove();
          }

          if (options.is_cached) {
            window.sessionStorage.setItem(
              options.getCacheKey(options.id),
              container.html()
            );
          }

          if (options.onLoad) {
            options.onLoad(newContent, container);
          }
          loading = false;
          if (setThreshold) {
            // won't exist if not auto-loading
            setThreshold();
          }
        });
      }
    }

    container.on("click", options.nextSelector, function() {
      append(options.get_url($(this)));
      return false;
    });

    var obj = {
      cancel: cancelXhr
    };

    function resize(w, h) {
      winHeight = h;
      winWidth = w;
      containerOffset = container.offset();
      setThreshold();
    }

    function scroll(t, l) {
      var v = options.vertical ? t : l;

      if (v > autoLoadThreshold) {
        container.find(options.nextSelector).trigger("click");
      }
    }

    if (options.autoOffset) {
      container.find(options.nextSelector).hide();

      setThreshold = function() {
        if (options.vertical) {
          if (winHeight === undefined) {
            return;
          }
          autoLoadThreshold =
            containerOffset.top +
            container.outerHeight() -
            winHeight -
            options.autoOffset;
        } else {
          if (winWidth === undefined) {
            return;
          }
          autoLoadThreshold =
            containerOffset.left +
            container.outerWidth() -
            winWidth -
            options.autoOffset;
        }
      };

      // if (options.bind) {
      //   bind_handlers(resize, scroll);
      // }
      obj.resize = resize;
      obj.setThreshold = setThreshold;
      obj.scroll = scroll;
    }
    return obj;
  }

  return InfScr;
});
